@if (subscription && !isOne && !isOneTrial) {
  <span>
    <span class="text-lowercase">{{ 'subscription_type_cloud' | i18next }}</span>
    @if (subscription.parent_name) {
      <span>
        -&nbsp;{{subscription.parent_name}}
      </span>
    }
  </span>
}

@if (subscription && isOne) {
  <span>
    {{ 'pascom_one_product_name' | i18next }}
  </span>
}
@if (subscription && isOneTrial) {
  <span>
    {{ 'pascom_one_trial_product_name' | i18next }}
  </span>
}
